import { FC } from 'react'
import classNames from 'classnames'
import { slugs } from '@/constants/slugs'

interface Props {
  theatricalSlug: string
  isFooter?: boolean
  logoUrl: string
}

export const GiveawayLogo: FC<Props> = ({ logoUrl, theatricalSlug, isFooter }) => {
  return (
    <img
      alt="logo"
      className={classNames(
        'mx-auto md:mx-0',
        theatricalSlug === slugs.homestead && !isFooter && 'w-[265px] h-[132px]',
        theatricalSlug === slugs.homestead && isFooter && 'w-[160px] h-[80px]',
        theatricalSlug === slugs.braveTheDark && !isFooter && 'w-[129px] h-[60px] md:w-[185px] md:h-[88px] mb-2',
        theatricalSlug === slugs.braveTheDark && isFooter && 'w-[101px] h-[48px]',
        (theatricalSlug === slugs.ruleBreakers || theatricalSlug === 'rule-breakers-tech') &&
          !isFooter &&
          'w-[293px] h-[44px] md:w-[370px] md:h-[56px]',
        (theatricalSlug === slugs.ruleBreakers || theatricalSlug === 'rule-breakers-tech') &&
          isFooter &&
          'w-[150px] h-[23px]',
        theatricalSlug === slugs.kingOfKings && !isFooter && 'w-[161px] h-[103px] md:w-[240px] md:h-[153px]',
        theatricalSlug === slugs.kingOfKings && isFooter && 'w-[140px] h-[89px]',
        theatricalSlug === slugs.theLastRodeo && !isFooter && 'w-[201px] h-[58px] md:h-[94px] md:w-[327px]',
        theatricalSlug === slugs.theLastRodeo && isFooter && 'w-[142px] h-[41px]',
      )}
      src={logoUrl}
    />
  )
}
